import {Component, Input, OnInit, Output, EventEmitter} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';

@Component({
    selector: 'acabim-user-add-data',
    templateUrl: './add-data.component.html',
    styleUrls: ['./add-data.component.scss']
})
export class AddDataComponent implements OnInit {
    @Input() title: string | undefined;
    @Input() type = 'email';
    @Input() validator: Validators | undefined;

    @Output() cancel = new EventEmitter<FormGroup>();


    validators = [Validators.required];

    // @ts-ignore
    addNewUserForm: FormGroup;

    addDataOptions = [{label: 'work', value: 'work'},
        {label: 'home', value: 'home'}];

    disableDefault = false;

    constructor() {
    }

    ngOnInit(): void {

        // tslint:disable-next-line:prefer-const
        if (this.validator !== undefined) {
            // @ts-ignore
            this.validators.push(this.validator);
        }
        if (this.title?.includes('Email')) {
            this.disableDefault = true;
        }
        this.addNewUserForm = new FormGroup({
            type: new FormControl({label: 'work', value: 'work'}),
            detail: new FormControl(null, this.validators),

            default: new FormControl({value: false, disabled: this.disableDefault}),
        });
        this.disableDefault = false;
    }

    onClose() {
        this.cancel.emit(undefined);
    }

    onSubmit() {
        this.cancel.emit(this.addNewUserForm);
    }
}

